import React from 'react';
import './CustomerSupportPage.css';
import CustomerSupportComponent from './CustomerSupportComponent';

const CustomerSupportPage = ({ user, userPermissions, setToast }) => {
  return (
    <div className="customer-support-page">
      <h1>Customer Support</h1>
      <CustomerSupportComponent user={user} userPermissions={userPermissions} setToast={setToast} />
    </div>
  );
};

export default CustomerSupportPage;
